import { fetcher } from "helpers/fetcher";

import { TUpdateOrganizationReq, TUpdateOrganizationRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const updateOrganization = async (payload: TUpdateOrganizationReq) => {
  return await fetcher<TUpdateOrganizationRes, TUpdateOrganizationReq["data"]>(
    ENDPOINT.CORPORATION.UPDATE_ORGANIZATION,
    {
      data: payload.data,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.CORPORATION.UPDATE_ORGANIZATION.version,
        [API_HEADER.CORP_ID]: payload.idCorp,
      },
    }
  );
};

export const mutationUpdateOrganization = async (
  payload: TUpdateOrganizationReq
) => {
  return (await updateOrganization(payload)).data;
};

mutationUpdateOrganization._key = (payload: TUpdateOrganizationReq) => [
  ENDPOINT.CORPORATION.UPDATE_ORGANIZATION.url,
  payload,
];
